import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, CardActions, Modal, Box, Select, InputLabel, Divider } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
// import Customers from './Customers';
import ReportsHeader from './ReportsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
    };
}

export interface IState {
    pageSize: number;
    anchorEl: any;
    pause_pickup_data: any[];
    showAddAgent: boolean;
    agentName: string;
    agentMobile: string;
    agentEmail: string;
    agentType: string;
    agentCity: string;
    filter: any;
    status: any;
    start_date: any;
    end_date: any;
}

class SummaryReport extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            pageSize: 5,
            anchorEl: null,
            pause_pickup_data: [],
            showAddAgent: false,
            agentName: '',
            agentMobile: '',
            agentEmail: '',
            agentType: '',
            agentCity: '',
            filter: '',
            status: '',
            start_date: '',
            end_date: '',
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        this.setState({
            pause_pickup_data:[
                {
                    'id': 134,
                    'start_date': '21st Mar',
                    'status': 'Active',
                    'house_number': 'aa',
                    'community': 'bb',
                    'community_group': 'aab',
                    'community_address': 'abcd',
                    'pincode': '500032',
                    'city': 'Hyd',
                    'community_status': 'Active',
                    'priority_type': 'P1',
                    'partners_name': 'James',
                    'bag_id': 'B001234',
                    'bag_assignment_date': '25th Mar',
                    'bag_distribution_date': '4th Sep',
                    'bag_distribution_type': 'Regular',
                    'purchased_bag_cost': '10',
                    'bag_distribution_agent': 'babu',
                    'pickup_date': '5th Oct',
                    'pickup_freq': 'weekly',
                    'pickup_agent': 'pankaj',
                    'bag_pickup_status': 'Pending',
                    'bag_lost': 'No',
                    'weighing_date': '6th Oct',
                    'weight': '3.2',
                    'per_kg_price': '5',
                    'amount_paid': '16',
                    'paid_to_hh': '3',
                    'paid_to_comm': '1',
                    'paid_to_partner': '1',
                    'mh_charge': '3',
                    'scan_date': '12th Oct',
                    'scanner_name': 'yyy',
                    'bad_good': 'bad',
                    'badbag_price_rollback': '-16',
                    'badbag_penalty': '30',
                    'sku_in_bag': '21',
                    'pause_from': '10th Aug',
                    'pause_to': '25th Aug',
                    'current_inventory': '30',
                    'inventory_allowed': '12',
                },
                {
                    'id': 136,
                    'start_date': '21st Mar',
                    'status': 'Active',
                    'house_number': 'aa',
                    'community': 'bb',
                    'community_group': 'aab',
                    'community_address': 'abcd',
                    'pincode': '500032',
                    'city': 'Hyd',
                    'community_status': 'Active',
                    'priority_type': 'P1',
                    'partners_name': 'James',
                    'bag_id': 'B001234',
                    'bag_assignment_date': '25th Mar',
                    'bag_distribution_date': '4th Sep',
                    'bag_distribution_type': 'Regular',
                    'purchased_bag_cost': '10',
                    'bag_distribution_agent': 'babu',
                    'pickup_date': '5th Oct',
                    'pickup_freq': 'weekly',
                    'pickup_agent': 'pankaj',
                    'bag_pickup_status': 'Pending',
                    'bag_lost': 'No',
                    'weighing_date': '6th Oct',
                    'weight': '3.2',
                    'per_kg_price': '5',
                    'amount_paid': '16',
                    'paid_to_hh': '3',
                    'paid_to_comm': '1',
                    'paid_to_partner': '1',
                    'mh_charge': '3',
                    'scan_date': '12th Oct',
                    'scanner_name': 'yyy',
                    'bad_good': 'bad',
                    'badbag_price_rollback': '-16',
                    'badbag_penalty': '30',
                    'sku_in_bag': '21',
                    'pause_from': '10th Aug',
                    'pause_to': '25th Aug',
                    'current_inventory': '30',
                    'inventory_allowed': '12',
                }
              ]
              
              
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);

        const handleAddAgent = (() => {
            this.setState({ showAddAgent: false });
            toast.success("Agent added", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });

        const columns = [
            {
                headerName: "Bintix UID",
                field: "id",
                width: 100,
              },
              {
                headerName: "Start Date",
                field: "start_date",
                width: 150,
              },
              {
                headerName: "Status",
                field: "status",
                width: 150,
              },
              {
                headerName: "House No.",
                field: "house_number",
                width: 200,
              },
              {
                headerName: "Community",
                field: "community",
                width: 100,
              },
              {
                headerName: "Community Group",
                field: "community_group",
                width: 150,
              },
              {
                headerName: "Community Address",
                field: "community_address",
                width: 100,
              },
              {
                headerName: "Pincode",
                field: "pincode",
                width: 100,
              },
              {
                headerName: "City",
                field: "city",
                width: 100,
              },
              {
                headerName: "Community Status",
                field: "community_status",
                width: 100,
              },
              {
                headerName: "Priority Type",
                field: "priority_type",
                width: 100,
              },
              {
                headerName: "Partner Name",
                field: "partners_name",
                width: 100,
              },
              {
                headerName: "Bag ID",
                field: "bag_id",
                width: 100,
              },
              {
                headerName: "Bag Assignment Date",
                field: "bag_assignment_date",
                width: 100,
              },
              {
                headerName: "Bag Distribution Date",
                field: "bag_assignment_date",
                width: 100,
              },
              {
                headerName: "Bag Distribution Type",
                field: "bag_distribution_type",
                width: 100,
              },
              {
                headerName: "Purchased Bag Cost",
                field: "purchased_bag_cost",
                width: 100,
              },
              {
                headerName: "Bag Distribution Agent",
                field: "bag_distribution_agent",
                width: 100,
              },
              {
                headerName: "Pickup Date",
                field: "pickup_date",
                width: 100,
              },
              {
                headerName: "Pickup Frequency",
                field: "pickup_freq",
                width: 100,
              },
              {
                headerName: "Pickup Agent",
                field: "pickup_agent",
                width: 100,
              },
              {
                headerName: "Bag Pickup Status",
                field: "bag_pickup_status",
                width: 100,
              },
              {
                headerName: "Bag Lost",
                field: "bag_lost",
                width: 100,
              },
              {
                headerName: "Weighing Date",
                field: "weighing_date",
                width: 100,
              },
              {
                headerName: "Weight",
                field: "weight",
                width: 100,
              },
              {
                headerName: "Per kg Price",
                field: "per_kg_price",
                width: 100,
              },
              {
                headerName: "Amount Paid",
                field: "amount_paid",
                width: 100,
              },
              {
                headerName: "Paid To HH",
                field: "paid_to_hh",
                width: 100,
              },
              {
                headerName: "Paid To Community",
                field: "paid_to_comm",
                width: 100,
              },
              {
                headerName: "Paid To Partner",
                field: "paid_to_partner",
                width: 100,
              },
              {
                headerName: "M & H Charge",
                field: "mh_charge",
                width: 100,
              },
              {
                headerName: "Scan Date",
                field: "scan_date",
                width: 100,
              },
              {
                headerName: "Scanner Name",
                field: "scanner_name",
                width: 100,
              },
              {
                headerName: "Bad/Good",
                field: "bad_good",
                width: 100,
              },
              {
                headerName: "Bad Bag Price Rollback",
                field: "badbag_price_rollback",
                width: 100,
              },
              {
                headerName: "Bad Bag Penalty",
                field: "badbag_penalty",
                width: 100,
              },
              {
                headerName: "SKU In Bag",
                field: "sku_in_bag",
                width: 100,
              },
              {
                headerName: "Pause From",
                field: "pause_from",
                width: 100,
              },
              {
                headerName: "Pause To",
                field: "pause_to",
                width: 100,
              },
              {
                headerName: "Current Inventory",
                field: "current_inventory",
                width: 100,
              },
              {
                headerName: "Inventory Allowed",
                field: "inventory_allowed",
                width: 100,
              },
          ];
          

        return (
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <ReportsHeader  user={this.props.user}/>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={<>
                                    <Grid container spacing={2}>
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("List of Customers")}</Typography>
                                        </Grid>
                                        
                                        {/* <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    // onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.fetchRoutes())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid> */}
                                    </Grid>
                                </>
                                }
                                className="text-left"
                                action={
                                    <CardActions>
                                        <Button variant="contained" size="small" sx={{ outline: 'none !important' }} 
                                        // onClick={() => this.setState({ showAddAgent: true })}
                                        >
                                            Download
                                        </Button>
                                    </CardActions>
                                }
                            />

                            <CardContent>
                                <DataGrid
                                    aria-label="List of Barcoded Bags"
                                    columns={columns}
                                    rows={this.state.pause_pickup_data}
                                    pageSize={this.state.pageSize}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                    rowsPerPageOptions={[2, 5, 10, 20]}
                                    autoHeight={true}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/neighbourhood/customers/' + params.id)
                                    }}
                                    className="clickableList"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showAddAgent}
                    onClose={() => this.setState({ showAddAgent: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title="Add Agent"
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddAgent: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="agent-name-input"
                                            label="Agent Name *"
                                            value={this.state.agentName}
                                            onChange={(e: any) => this.setState({ agentName: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="agent-mobile-input"
                                            label="Mobile Number *"
                                            value={this.state.agentMobile}
                                            onChange={(e: any) => this.setState({ agentMobile: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="agent-email-input"
                                            label="Email *"
                                            type={'email'}
                                            value={this.state.agentEmail}
                                            onChange={(e: any) => this.setState({ agentEmail: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    {/* <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="agent-type-label">Agent Type *</InputLabel>
                                            <Select
                                                labelId="agent-type-label"
                                                value={this.state.agentType}
                                                onChange={(e) => this.setState({ agentType: e.target.value })}
                                                displayEmpty
                                                label="Agent Type *"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={1} value={'Payment Collection Agent'}>Payment Collection Agent</MenuItem>
                                                <MenuItem key={2} value={'Waste Administration Agent'}>Waste Administration Agent</MenuItem>
                                                <MenuItem key={3} value={'Waste and Administration Agent'}>Waste and Administration Agent</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid> */}
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">City *</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.agentCity}
                                                onChange={(e) => this.setState({ agentCity: e.target.value })}
                                                displayEmpty
                                                label="City *"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={1} value={1}>Mumbai</MenuItem>
                                                <MenuItem key={2} value={2}>Delhi</MenuItem>
                                                <MenuItem key={3} value={3}>Bangalore</MenuItem>
                                                <MenuItem key={4} value={4}>Chennai</MenuItem>
                                                <MenuItem key={5} value={5}>Kolkata</MenuItem>
                                                <MenuItem key={6} value={6}>Hyderabad</MenuItem>
                                                <MenuItem key={7} value={7}>Pune</MenuItem>
                                                <MenuItem key={8} value={8}>Ahmedabad</MenuItem>
                                                <MenuItem key={9} value={9}>Jaipur</MenuItem>
                                                <MenuItem key={10} value={10}>Lucknow</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddAgent: false })}>Close</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleAddAgent()}>Add Agent</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(SummaryReport))